// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';

import type { TestId } from '@trello/test-ids';

import type { IconSize } from '../src/components/Icon';
import { Icon } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon.
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default token('color.icon', '#42526E')
   */
  color?: string;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-testid) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId | string;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const JiraIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0H0V24H24V0Z" fill="transparent" fillOpacity="0.01" />
      <path
        d="M20.73 2.25H11.55C11.55 4.4925 13.41 6.3225 15.69 6.3225H17.385V7.9125C17.385 10.155 19.245 11.985 21.525 11.985V3.03C21.525 2.5875 21.18 2.25 20.73 2.25Z"
        fill="currentColor"
      />
      <path
        d="M16.1925 6.74255H7.01251C7.01251 8.98505 8.87251 10.8151 11.1525 10.8151H12.8475V12.4351C12.8475 14.6776 14.7075 16.5076 16.9875 16.5076V7.52255C16.9875 7.11005 16.6425 6.74255 16.1925 6.74255Z"
        fill="currentColor"
      />
      <path
        d="M11.655 11.2574H2.47498C2.47498 13.4999 4.33498 15.3299 6.61498 15.3299H8.30998V16.9199C8.30998 19.1624 10.17 20.9924 12.45 20.9924V12.0449C12.45 11.6024 12.0825 11.2574 11.655 11.2574Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const JiraIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId || 'JiraIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={JiraIconGlyph}
    />
  );
};
